import { CustomForm, showErrorMessage } from '../../../shared/components/index';
import { Box, Typography, Card } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldType } from '../../../shared/components/form-field/service/formFieldInterface';
import {
  I18N,
  TENANT_ROLES,
  ROLES,
  BookingStatus,
  DepositeStatus,
  PAYMENT_METHOD
} from '../../../shared/constants/constants';
import { useSelector } from 'react-redux';
import { selectUserState } from 'src/auth/login/services/userSlice';
import { AssetGroup, CreatedAssetGroup } from '../../Asset-group/models/index';
import { AssetType } from 'src/modules/Asset-type/models';
import { Booking, BookingAsset } from '../models';
import dayjs from 'dayjs';
const AddBookingModal = ({
  isAddModal,
  open,
  assetGroupList,
  assetList,
  onClose,
  onSubmit,
  handleClose,
  editObject
}) => {
  const [fields, setFields] = useState([] as FormFieldType[]);
  const { i18n, t } = useTranslation(I18N.DEFAULT);
  const { loginUserRole } = useSelector(selectUserState);
  const [selectedAssetList, setSelectedAssetList] = useState([]);
  const [isSingleDate, setIsSingleDate] = useState(true);
  const [createdAssetGroupList, setCreatedAssetGroupList] = useState([]);
  const configurableRole =
    loginUserRole == ROLES.TENANT_OPERATOR
      ? [TENANT_ROLES[1], TENANT_ROLES[2]]
      : TENANT_ROLES;
  const [initialValues, setInitialValues] = useState({});
  const formValue = {
    name: '',
    billNo: '',
    reference: '',
    mobile: '',
    alternativeMobile: '',
    deliveryDate: dayjs(new Date()),
    returnDate: dayjs(new Date()),
    isSameDateDelivery: true,
    paymentMethod: PAYMENT_METHOD[1].id,
    rent: '',
    advance: '',
    depositeStatus: DepositeStatus[1].id,
    remark: '',
    depositeAmount: '',
    bookingStatus: BookingStatus[1].id,
    address: ''
  };

  useEffect(() => {
    setInitialValues({ ...formValue });
  }, []);

  const autoGeneratedCustomFormFields: FormFieldType[] = [{
    id: 'billNo',
    name: 'billNo',
    type: 'text',
    label: 'bill-no',
    validations: {
      required: true,
    },
    errorMessages: {
      requiredErrMsg: 'bill_no is required',
    }
  }];

  const handleAssetSelectChange = (event, field, value, form) => {
    var result = assetList.find(function (e) {
      return value && e.id == value.id;
    });

    // createdAssetGroupList.forEach((assetGroupSelect: CreatedAssetGroup) => { 
    //   assetGroupSelect?.assetGroup?.assetTypes?.forEach((assetType: AssetType) => {
    //     //${assetGroupSelect.id}_${assetType.id}
    //     debugger;
    //     console.log("assetGroupSelect.id", assetGroupSelect.id);
    //     console.log("assetType.id", assetType.id);
    //   });
    // });

    const assetsList = [...selectedAssetList]
    assetsList.push(result);
    setSelectedAssetList(assetsList);
    setInitialValues((prevValues) => ({
      ...prevValues,
      [field.name]: result,
    }));
  };

  const handleInputChange = (event, field) => {
    let value = null;
    if (event.$isDayjsObject) {
      value = new Date(event.$d);
    } else {
      value = event.target.value;
    }
    const fieldName: string = field.name;

    if (field.name === "isSameDateDelivery") {
      value = event.target.checked;
      setIsSingleDate(value);
    }

    setInitialValues((prevValues) => ({
      ...prevValues,
      [field.name]: value,
    }));

    // Update createdAssetGroupList based on fieldName
    if (fieldName.includes("asset_group_")) {
      const filteredList = assetGroupList.filter((item) => item.id === value);
      const selectedAssetGroup = filteredList[0];
      setCreatedAssetGroupList((prevList) => {
        const updatedList = [...prevList];
        const index = updatedList.findIndex((item) => item.name === field.name);
        if (index !== -1) {
          updatedList[index] = { ...updatedList[index], assetGroup: selectedAssetGroup, assetGroupId: value };
        }
        return updatedList;
      });
    }
  };

  const handleAddAssetGroupButtonClick = (submitedValues: any) => {
    const groupId = new Date().getTime();
    const groupName = `asset_group_${groupId}`;
    const assetGroupList = [...createdAssetGroupList, { id: groupId, name: groupName }];
    setCreatedAssetGroupList(assetGroupList);
  };

  const handleRemoveAssetGroupButtonClick = (id: string, name: string) => {
    setCreatedAssetGroupList((prevList) => prevList.filter((item) => item.name !== name));
  };

  useEffect(() => {
    const assetFields = [];
    const initValue = {};
    createdAssetGroupList.forEach((assetGroupSelect: CreatedAssetGroup) => {
      assetFields.push({
        type: 'divider',
        label: assetGroupSelect?.assetGroup?.name
      });
      if (!isSingleDate) {

        assetFields.push({
          id: `${assetGroupSelect.id}_deliveryDate`,
          name: `${assetGroupSelect.id}_deliveryDate`,
          type: 'dateTimePicker',
          label: `${assetGroupSelect?.assetGroup?.name || ''} delivery-date`,
          handleFieldChange: handleInputChange,
          col: 2.5,
          validations: {
            //required: true,
            maxLength: 50
          },
          errorMessages: {
            requiredErrMsg: 'delivery date is required'
          }
        });

        assetFields.push({
          id: `${assetGroupSelect.id}_returnDate`,
          name: `${assetGroupSelect.id}_returnDate`,
          type: 'dateTimePicker',
          col: 2.5,
          label: `${assetGroupSelect?.assetGroup?.name || ''} return-date`,
          handleFieldChange: handleInputChange,
          validations: {
            //required: true
          },
          errorMessages: {
            requiredErrMsg: 'return date is required'
          }
        });
        initValue[`${assetGroupSelect.id}_deliveryDate`] = initialValues[`${assetGroupSelect.id}_deliveryDate`] || dayjs(new Date());
        initValue[`${assetGroupSelect.id}_returnDate`] = initialValues[`${assetGroupSelect.id}_returnDate`] || dayjs(new Date());
      }
      assetFields.push({
        id: 'assetGroup',
        name: assetGroupSelect.name,
        type: 'select',
        label: t('booking.assetgroup'),
        col: 2.5,
        options: [{ id: '', name: 'select any one' }, ...assetGroupList],
        itemValueKey: 'id',
        itemLabelKey: 'name',
        handleFieldChange: handleInputChange,
        validations: {
          required: true
        },
        errorMessages: {
          requiredErrMsg: 'value is required'
        }
      });
      initValue[assetGroupSelect.name] = initialValues[assetGroupSelect.name] || '';
      assetFields.push({
        id: 'crossIcon',
        name: 'crossIcon',
        type: 'crossIcon',
        col: 2.5,
        itemValueKey: assetGroupSelect.id,
        itemLabelKey: assetGroupSelect.name,
        handleOnClick: handleRemoveAssetGroupButtonClick,
      });
      if (initialValues[assetGroupSelect.name]) {
        assetFields.push({
          type: 'divider',
          label: 'Selected from List'
        });
        assetGroupSelect?.assetGroup?.assetTypes?.forEach((assetType: AssetType) => {
          const assets = assetList.filter(function (e) {
            return e.typeId == assetType.id;
          })
          assetFields.push({
            id: `${assetGroupSelect.id}_${assetType.id}`,
            name: `${assetGroupSelect.id}_${assetType.id}`,
            type: 'autocomplete',
            value: '',
            col: 2.5,
            label: assetType.name,
            options: [{ id: '', label: 'select any one' }, ...assets],
            itemValueKey: 'id',
            itemLabelKey: 'label',
            handleFieldChange: handleAssetSelectChange,
            validations: {
              //required: true
            },
            errorMessages: {
              requiredErrMsg: `${assetType.name} is required`
            }
          });
          initValue[`${assetGroupSelect.id}_${assetType.id}`] = initialValues[`${assetGroupSelect.id}_${assetType.id}`] || '';
        });
        assetFields.push({
          type: 'divider',
          label: ''
        });
      }
    });

    assetFields.push({
      type: 'divider',
      label: ''
    });
    const fields = [
      ...basePreCustomFormFields,
      ...assetFields, ...basePostCustomFormFields
    ];
    setFields(fields);
    setInitialValues((prevValues) => ({
      ...prevValues,
      ...initValue
    }));
  }, [createdAssetGroupList, isSingleDate]);

  function validateDates(deliveryDate, returnDate, assetName) {
    if (!deliveryDate || !returnDate) {
      return showErrorMessage((assetName ? assetName : "") + t(!deliveryDate ? 'booking.error.delivery-date' : 'booking.error.return-date'), {
        theme: 'colored',
        position: 'top-right',
        autoClose: 5000
      });
    } else if (new Date(deliveryDate).getTime() > new Date(returnDate).getTime()) {
      return showErrorMessage(t(!deliveryDate ? 'booking.error.delivery-date' : 'booking.error.return-date'), {
        theme: 'colored',
        position: 'top-right',
        autoClose: 5000
      });
    }
    return true;
  }

  const prepareBookingAndSubmit = (submitedValues: Booking) => {
    const values: Booking = { ...submitedValues };
    const isSameDateDelivery = submitedValues.isSameDateDelivery;
    if (isSameDateDelivery) {
      if (validateDates(values.deliveryDate, values.returnDate, null) !== true) {
        return;
      }
    }
    const bookingAssets: BookingAsset[] = [];
    let groupId = 0;
    createdAssetGroupList.forEach((craetedAssetGroup: CreatedAssetGroup) => {
      groupId++;
      craetedAssetGroup?.assetGroup?.assetTypes.forEach((assetType: AssetType) => {
        const bookingAsset: BookingAsset = new BookingAsset();
        bookingAsset.groupId = groupId;
        bookingAsset.assetGroup = craetedAssetGroup?.assetGroup;
        const assets = assetList.find(function (e) {
          const currentAsset = values[`${craetedAssetGroup.id}_${assetType.id}`];
          return e.id == currentAsset?.id;
        });
        bookingAsset.asset = assets;
        if (isSameDateDelivery) {
          bookingAsset.deliveryDate = values[`deliveryDate`];
          bookingAsset.returnDate = values[`returnDate`];
        } else {
          if (validateDates(values[`${craetedAssetGroup.id}_deliveryDate`], values[`${craetedAssetGroup.id}_returnDate`], assets?.name) !== true) {
            return;
          }
          bookingAsset.deliveryDate = values[`${craetedAssetGroup.id}_deliveryDate`];
          bookingAsset.returnDate = values[`${craetedAssetGroup.id}_returnDate`];
        }
        bookingAssets.push(bookingAsset);
      });
    });
    values.bookingAssets = bookingAssets;
    onSubmit(values);
  };

  const basePreCustomFormFields: FormFieldType[] = [
    {
      id: 'name',
      col: 5.5,
      name: 'name',
      type: 'multi-text',
      label: t('name'),
      handleFieldChange: handleInputChange,
      validations: {
        required: true,
      },
      errorMessages: {
        requiredErrMsg: 'name is required',
      }
    },
    {
      id: 'mobile',
      name: 'mobile',
      col: 2.5,
      type: 'regex',
      label: t('booking.mobile'),
      handleFieldChange: handleInputChange,
      validations: {
        regex: /[789][0-9]{9}/,
        minLength: 10,
        maxLength: 10,
        required: true,
      },
    },
    {
      id: 'alternativeMobile',
      name: 'alternativeMobile',
      col: 2.5,
      type: 'regex',
      label: t('booking.alternative-mobile'),
      handleFieldChange: handleInputChange,
      validations: {
        regex: /^$|^[789][0-9]{9}$/,
        minLength: 10,
        maxLength: 10,
      },
    },
    {
      id: `isSameDateDelivery`,
      name: `isSameDateDelivery`,
      type: 'checkbox',
      label: t('booking.single-date-delivery-return'),
      col: 4,
      handleFieldChange: handleInputChange,
      isChecked: true,
    },
    {
      id: `deliveryDate`,
      name: `deliveryDate`,
      type: 'dateTimePicker',
      label: t('booking.error.delivery-date'),
      col: 2.5,
      isDisabled: !isSingleDate,
      handleFieldChange: handleInputChange,
      validations: {
        required: isSingleDate,
        maxLength: 50
      },
      errorMessages: {
        requiredErrMsg: 'delivery date is required'
      }
    },
    {
      id: `returnDate`,
      name: `returnDate`,
      type: 'dateTimePicker',
      col: 2.5,
      isDisabled: !isSingleDate,
      handleFieldChange: handleInputChange,
      label: t('booking.error.return-date'),
      validations: {
        required: isSingleDate
      },
      errorMessages: {
        requiredErrMsg: 'return date is required'
      }
    }
  ];

  const basePostCustomFormFields: FormFieldType[] = [
    {
      id: 'addIcon',
      name: 'addIcon',
      type: 'addIcon',
      handleFieldChange: handleAddAssetGroupButtonClick,
    },
    {
      id: 'rent',
      col: 2,
      name: 'rent',
      type: 'integer_only',
      label: t('booking.rent'),
      handleFieldChange: handleInputChange,
      validations: {
        required: true,
      },
      errorMessages: {
        requiredErrMsg: 'rent is required',
      }
    },
    {
      id: 'advance',
      col: 2,
      name: 'advance',
      type: 'integer_only',
      label: t('booking.advance'),
      handleFieldChange: handleInputChange,
      validations: {
        required: true
      },
      errorMessages: {
        requiredErrMsg: 'advance is required',
      }
    },
    {
      id: 'depositeAmount',
      name: 'depositeAmount',
      type: 'integer_only',
      label: t('booking.deposite'),
      handleFieldChange: handleInputChange,
      col: 2,
      errorMessages: {
        requiredErrMsg: 'deposite amount is required'
      }
    },
    {
      id: 'paymentMethod',
      name: 'paymentMethod',
      type: 'select',
      options: PAYMENT_METHOD,
      itemLabelKey: 'name',
      itemValueKey: 'id',
      label: t('booking.paymenttype'),
      handleFieldChange: handleInputChange,
      col: 2,
      errorMessages: {
        requiredErrMsg: 'deposite amount is required'
      }
    },
    {
      id: 'reference',
      name: 'reference',
      col: 2.5,
      type: 'multi-text',
      handleFieldChange: handleInputChange,
      label: t('booking.reference'),
    },
    {
      id: 'remark',
      col: 2.5,
      name: 'remark',
      type: 'freetext',
      label: t('booking.remark'),
      handleFieldChange: handleInputChange,
      errorMessages: {
        requiredErrMsg: 'remark is required'
      }
    },
    {
      id: 'address',
      name: 'address',
      col: 6.5,
      type: 'freetext',
      handleFieldChange: handleInputChange,
      label: t('booking.address'),
    },
  ];

  useEffect(() => {
    if (isAddModal) {
      handleAddUserButtonClick();
    } else {
      handleEditIconClick(editObject);
    }
  }, [open]);
  const handleAddUserButtonClick = () => {
    const fields = [
      ...basePreCustomFormFields,
      //...baseAssetCustomFormFields, 
      ...basePostCustomFormFields
    ];
    setFields(fields);
  };
  const handleEditIconClick = (row) => {
    const formFields = [...basePreCustomFormFields,
      //...baseAssetCustomFormFields
    ];
    formFields.map((field) => {
      field.isDisabled = true;
      return field;
    });
    setFields([...formFields, ...basePostCustomFormFields]);

    const initialFormValue = {
      name: row.name,
      bookingDate: row.bookingDate,
      billNo: row.billNo,
      reference: row.reference,
      mobile: row.mobile,
      alternativeMobile: row.alternativeMobile,
      deliveryDate: row.deliveryDate,
      paymentMethod: PAYMENT_METHOD[1].id,
      returnDate: row.returnDate,
      rent: row.rent,
      advance: row.advance,
      depositeStatus: row.depositeStatus,
      remark: row.remark,
      depositeAmount: row.depositeAmount,
      bookingStatus: row.bookingStatus,
      address: row.address
    };
    setInitialValues(initialFormValue);
  };
  return (
    <Card className="mb-24">
      {' '}
      <Typography sx={{ p: 3, pl: 2 }} variant="h4" fontWeight="bold">
        {isAddModal ? t('booking.add-booking') : t('booking.edit-booking')}
      </Typography>
      <Box sx={{ p: 1 }}>
        <CustomForm
          formFields={fields}
          enableReinitialize={true}
          initialValues={initialValues}
          submitBtnHandler={prepareBookingAndSubmit}
          cancelBtnHandler={handleClose}
          resetOnSubmit={false}
        />
      </Box>
    </Card>
  );
};

export default AddBookingModal;
